export const OFF_PLATFORM_SOURCE = 'off_platform';

export type SourceableCreator = {
  id?: string;
  source?: string | null;
  userId?: string | null;
};

export function isOffPlatformCreator(
  creator?: SourceableCreator | null
): boolean {
  return creator?.source === OFF_PLATFORM_SOURCE;
}
